import Html from './HtmlHelper.js';

class LoadConfigurationForm {
    _configurationService;
    _loadConfigurationForm;
    _shareKeyInputElement;
    _formSubmitButton;
    _dossierNotFoundMessage;
    _validationFailedMessage;
    _loadingSpinner;
    _validationTimeout = null;

    constructor(configurationService) {
        this._configurationService = configurationService;
        this._loadConfigurationForm = Html.getById('load-configuration-form');
        this._shareKeyInputElement = Html.getById('share-key-input');
        this._formSubmitButton = Html.select('.load-configuration-form__submit-btn');
        this._dossierNotFoundMessage = Html.getById('dossier-not-found');
        this._validationFailedMessage = Html.getById('validation-failed');
        this._loadingSpinner = Html.select('.load-configuration-form__loading-spinner');

        this._shareKeyInputElement.addEventListener('input', this._debounceValidation.bind(this));
        this._loadConfigurationForm.addEventListener('submit', this._submit.bind(this));
    }

    async _submit(event) {
        event.preventDefault();

        const shareKey = this._shareKeyInputElement.value;
        if (!shareKey) return;

        this._loadingSpinner.classList.add('is-active');

        await this._configurationService.getConfigurationByShareKey(shareKey);

        this._loadingSpinner.classList.remove('is-active');
    }

    _debounceValidation(event) {
        if (this._validationTimeout) {
            clearTimeout(this._validationTimeout);
        }
        this._validationTimeout = setTimeout(() => {
            this._validateShareKey(event);
        }, 500);
    }

    _validateShareKey(event) {
        const value = event.target.value.trim();
        if (value.length === 0 || this._dossierNotFound()) {
            this._clearInputValidation();
        } else if (!this._isValidShareKey(value)) {
            this._showInvalidMessage();
        } else {
            this._clearInputValidation();
        }
    }

    _clearInputValidation() {
        if (this._dossierNotFound()) {
            this._dossierNotFoundMessage.classList.remove('is-active');
        }
        if (this._validationFailedMessage.classList.contains('is-active')) {
            this._validationFailedMessage.classList.remove('is-active');
        }
    }

    _isValidShareKey(value) {
        if (value.length !== 38) return false;
        if (!this._isValidDatePrefix(value)) return false;
        return this._isValidId(value);
    }

    _isValidDatePrefix(value) {
        const datePrefix = value.slice(0, 6);
        const containsOnlyDigits = new RegExp('^[0-9]+$');
        return containsOnlyDigits.test(datePrefix);
    }

    _isValidId(value) {
        const id = value.slice(6);
        const containsOnlyDigitsAndLowerCase = new RegExp('^[a-z0-9]+$');
        return containsOnlyDigitsAndLowerCase.test(id);
    }

    _showInvalidMessage() {
        this._validationFailedMessage.classList.add('is-active');
    }

    _dossierNotFound() {
        return this._dossierNotFoundMessage.classList.contains('is-active');
    }
}

export default LoadConfigurationForm;